const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');

function updateFooterAccordions(footer) {
    const accordions = footer.querySelectorAll('.som-footer__accordion');

    accordions.forEach((accordion) => {
        if (!(accordion instanceof HTMLDetailsElement)) return;

        accordion.open = !MOBILE_QUERY.matches;
    });
}

function initializeFooters(root = document) {
    root.querySelectorAll('[data-som-footer]').forEach((footer) => {
        updateFooterAccordions(footer);
    });
}

initializeFooters();

MOBILE_QUERY.addEventListener('change', () => {
    initializeFooters();
});

document.addEventListener('shopify:section:load', (event) => {
    initializeFooters(event.target);
});